<template>
  <div class="index-down">
    <img
      :src="childItem.propsValue.data.customField1"
      width="100%"
      height="100%"
    />
    <h2>{{ childItem.propsValue.data.customField2 }}</h2>
    <a class="button-dow" download>{{
      childItem.propsValue.data.customField3.text
    }}</a>
  </div>
</template>

<script>
let buttonDataObject = {
  text: "立即下载",
  beforeClick: {
    type: 0, // 0 直接访问使用， 1 填写表单后有效
    form: "", // 表单ID，按钮点击需填写表单
    formtime: "无", // 表单有效期  无 一天 七天 永久
  },
  afterClick: {
    type: 1, // 点击后类型  0 无跳转，1 跳转页面  2 关联内容
    url: "",
    contentType: "data", // data 资料， article 文章， video 视频
    contentId: "",
  },
};
export default {
  name: "MkBaipishuPhone",
  props: {
    childItem: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      fields: [
        {
          code: "customField1",
          label: "图片",
          type: "image",
          width: 750,
          height: 190,
        },
        {
          code: "customField2",
          label: "白皮书",
          type: "text",
        },
        {
          code: "customField3",
          label: "按钮",
          type: "button",
        },
      ],
      data: {
        customField1:
          "https://mks.yybip.com/group1/M00/08/7D/CgoRC2LVBHaAEKwqAANCym3lTPs181.png",
        customField2: "白皮书名称",
        customField3: JSON.parse(JSON.stringify(buttonDataObject)),
      },
    };
  },
};
</script>

<style scoped lang="scss">
.index-down {
  width: 100%;
  height: 100%;
  text-align: center;
  position: relative;
}
.index-down > h2 {
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  font-size: 16px;
  color: #ffffff;
  letter-spacing: 0;
  position: absolute;
  text-align: center;
  width: 100%;
  top: 15px;
}
.index-down > .button-dow {
  position: absolute;
  display: block;
  width: 90px;
  height: 25px;
  line-height: 25px;
  background: #fffaff;
  border-radius: 3px;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  font-size: 10px;
  color: #e61318;
  letter-spacing: 0;
  text-align: center;
  border: none;
  bottom: 15px;
  margin: 0 auto;
  left: 0;
  right: 0;
}
</style>
